import React, { FC } from 'react';
import styled from 'styled-components';
import { DocumentProvider } from 'components/organisms/document/document-store';
import { Tools } from 'components/organisms/document/parts/topbar/types.d';
import { TemplateDocumentsPane } from './document-pane';
import { TemplateEditorProps } from './editor';

const Wrapper = styled.div`
  height: 100%;

  .editor__toolbar {
    padding: var(--spacing-03) var(--spacing-04);
  }
`;

export const TemplateRocketlaneDocument: FC<{
  docId: number;
  editorProps?: TemplateEditorProps;
  onTitleChange(title: string): void;
  tools?: Tools;
}> = (props) => {
  return (
    <Wrapper>
      <DocumentProvider>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <TemplateDocumentsPane {...props} />
      </DocumentProvider>
    </Wrapper>
  );
};
